var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDraft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 208,
    viewBox: "0 0 273 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.828 105.055C232.828 108.41 232.833 111.77 232.439 115.028C232.036 118.351 231.34 121.641 230.552 124.833C229.75 128.073 228.179 131.056 227.006 134.142C225.824 137.251 224.471 140.239 222.936 143.171C221.398 146.108 220.178 149.245 218.306 151.982C216.438 154.715 214.407 157.378 212.233 159.887C210.069 162.383 207.63 164.669 205.183 166.923C202.754 169.159 200.056 171.096 197.377 173.067C194.721 175.019 192.083 177.054 189.205 178.723C186.359 180.372 183.337 181.766 180.291 183.119C177.287 184.453 174.149 185.507 170.974 186.53C167.85 187.538 164.735 188.751 161.471 189.434C158.264 190.108 154.982 190.768 151.654 191.112C148.4 191.447 145.053 191.307 141.702 191.307C138.35 191.307 135.073 190.787 131.819 190.452C128.495 190.113 125.135 190.141 121.927 189.472C118.659 188.788 115.428 187.933 112.304 186.929C109.129 185.907 106.172 184.341 103.168 183.003C100.122 181.65 97.1419 180.224 94.2911 178.569C91.4125 176.901 88.8399 174.814 86.1838 172.858C83.5046 170.887 80.5843 169.228 78.16 166.993C75.7172 164.744 73.6776 162.095 71.5129 159.595C69.3389 157.085 67.012 154.687 65.1439 151.955C63.2712 149.217 61.8111 146.215 60.2675 143.278C58.7332 140.346 57.0459 137.455 55.8639 134.346C54.6912 131.261 54.1998 127.933 53.4025 124.699C52.6145 121.501 51.5159 118.332 51.1126 115.009C50.7186 111.752 50.5703 108.41 50.5703 105.05C50.5703 101.695 50.714 98.3489 51.108 95.0912C51.5113 91.7685 52.1278 88.4783 52.9158 85.281C53.7177 82.0419 54.7885 78.8771 55.9612 75.7914C57.1433 72.6824 59.0206 69.9033 60.5549 66.9756C62.0938 64.0386 63.1183 60.7809 64.9909 58.0437C66.859 55.3111 68.9681 52.6947 71.1467 50.1899C73.3114 47.6943 75.6708 45.3149 78.1183 43.061C80.5472 40.8257 83.5 39.1992 86.1792 37.2288C88.8353 35.277 91.3152 33.0277 94.1938 31.3547C97.0399 29.705 100.002 28.1667 103.043 26.8144C106.046 25.4806 109.212 24.4443 112.388 23.4219C115.512 22.4135 118.747 21.7117 122.015 21.0286C125.223 20.3548 128.435 19.3649 131.759 19.021C135.013 18.6864 138.36 18.784 141.706 18.784C145.053 18.784 148.4 18.7003 151.654 19.0349C154.977 19.3742 158.19 20.3687 161.397 21.0425C164.665 21.7257 167.864 22.5436 170.988 23.5474C174.163 24.5698 177.324 25.5736 180.328 26.9073C183.374 28.2597 186.164 30.0628 189.01 31.7172C191.889 33.3855 194.8 34.9702 197.456 36.9221C200.135 38.8925 202.851 40.835 205.28 43.0703C207.723 45.3196 209.795 47.9499 211.96 50.4455C214.134 52.955 216.41 55.3994 218.278 58.132C220.151 60.8692 221.643 63.8573 223.182 66.7944C224.716 69.7268 225.838 72.8404 227.02 75.9494C228.193 79.0351 229.069 82.1952 229.871 85.4297C230.659 88.627 231.34 91.8289 231.744 95.1517C232.138 98.4233 232.828 101.7 232.828 105.055Z",
    fill: "#F81958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.018 105.055C224.018 108.336 223.54 111.515 223.123 114.693C222.701 117.932 222.608 121.204 221.783 124.308C220.944 127.455 219.442 130.354 218.214 133.333C216.976 136.335 215.799 139.337 214.195 142.144C212.591 144.956 211.127 147.888 209.18 150.477C207.242 153.061 204.864 155.31 202.611 157.647C200.377 159.971 198.06 162.239 195.543 164.288C193.049 166.324 190.356 168.122 187.611 169.865C184.9 171.594 182.281 173.583 179.356 175C176.468 176.399 173.362 177.445 170.289 178.518C167.262 179.573 164.152 180.54 160.972 181.26C157.852 181.966 154.575 181.929 151.33 182.292C148.16 182.645 144.966 183.077 141.693 183.077C138.421 183.077 135.236 182.589 132.066 182.236C128.821 181.878 125.553 181.887 122.434 181.181C119.254 180.461 116.078 179.708 113.052 178.648C109.978 177.575 107.123 175.981 104.23 174.582C101.305 173.165 98.5382 171.505 95.8265 169.777C93.087 168.029 90.5005 166.119 88.0066 164.084C85.4943 162.03 82.6991 160.269 80.4602 157.945C78.2121 155.607 76.3811 152.879 74.4389 150.296C72.492 147.707 70.5637 145.081 68.9553 142.274C67.3514 139.468 66.4383 136.317 65.2052 133.319C63.9769 130.34 62.4148 127.459 61.5758 124.313C60.746 121.209 59.9024 118.035 59.4759 114.796C59.0634 111.621 58.9336 108.336 58.9336 105.055C58.9336 101.774 59.7541 98.5814 60.1712 95.4073C60.5931 92.1682 61.2235 89.0314 62.0532 85.9224C62.8922 82.7762 63.3882 79.5278 64.6166 76.5443C65.8542 73.5422 67.2773 70.5959 68.8811 67.7889C70.4849 64.9774 72.4132 62.3378 74.3601 59.7493C76.2977 57.1654 78.569 54.8418 80.8172 52.5089C83.0514 50.1853 85.2671 47.8013 87.7795 45.7472C90.2733 43.7117 92.985 41.9179 95.7245 40.1706C98.4362 38.4418 101.324 36.9919 104.249 35.5745C107.137 34.1757 109.988 32.5863 113.065 31.5082C116.092 30.4532 119.193 29.403 122.373 28.6826C125.493 27.9763 128.761 27.7439 132.006 27.3861C135.176 27.0329 138.416 27.2048 141.689 27.2048C144.961 27.2048 148.22 26.8377 151.395 27.1862C154.64 27.5441 157.862 28.0832 160.981 28.7895C164.161 29.5098 167.169 30.7971 170.192 31.852C173.265 32.9256 176.278 34.0874 179.166 35.4862C182.091 36.9036 184.737 38.7671 187.449 40.4912C190.189 42.2386 193.141 43.6606 195.635 45.6961C198.148 47.7502 200.275 50.2271 202.514 52.5507C204.762 54.8883 207.154 57.1097 209.092 59.6935C211.039 62.282 212.577 65.1586 214.181 67.9702C215.785 70.7771 217.528 73.5469 218.766 76.5443C219.994 79.5232 220.536 82.7623 221.375 85.9084C222.205 89.0128 223.332 92.0939 223.753 95.333C224.189 98.507 224.018 101.774 224.018 105.055Z",
    fill: "#180A0A"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M20.7517 42.4058C21.0901 42.2431 21.4238 42.0805 21.8966 41.8574C22.0913 43.0332 21.1272 43.4142 20.7285 44.0881C20.7332 43.5258 20.7424 42.9635 20.7517 42.4058Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M195.546 27.4558C194.749 29.3007 193.636 27.7718 192.732 27.953C191.796 25.8246 191.865 25.5736 194.063 23.566C194.174 23.9006 194.285 24.2492 194.401 24.5931C194.526 24.528 194.647 24.463 194.772 24.3979C194.61 25.095 194.447 25.7921 194.257 26.596C194.614 26.8423 195.045 27.1258 195.546 27.4558Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M28.6036 45.8262C28.2328 45.8216 27.9037 45.817 27.5931 45.8123C27.4216 45.4684 27.2501 45.1245 27.0137 44.6598C27.0183 44.2508 27.0276 43.6978 27.0322 43.4143C27.4818 42.8381 27.8156 42.4152 28.1911 41.9365C28.5063 42.1642 28.7149 42.313 28.9234 42.4617C29.1691 42.3222 29.4426 42.1735 29.7995 41.9737C30.3511 43.656 29.2062 44.6366 28.6036 45.8262Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M65.6967 79.235C66.2112 79.2443 66.6794 79.2489 67.1893 79.2536C67.18 79.7834 67.1754 80.2481 67.1661 80.7964C66.6887 80.7918 66.2251 80.7825 65.604 80.7732C65.3768 81.3169 65.159 81.8467 64.904 82.4602C64.6723 82.4555 64.3478 82.4509 63.9492 82.4462C63.9213 82.3068 63.8333 82.1163 63.8472 81.9304C63.9445 80.657 64.9643 80.0018 65.6967 79.235Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M219.837 30.2023C220.287 29.5563 220.597 29.1056 220.861 28.7291C222.178 29.0963 222.178 29.0963 222.206 30.4439C221.876 30.4579 221.547 30.4718 221.306 30.4811C220.926 30.9644 220.579 31.4013 220.138 31.9589C219.512 31.1503 219.883 30.4439 219.837 30.2023Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M94.1709 21.1401C94.6622 21.1448 95.0701 21.1541 95.631 21.1587C95.8257 21.9069 96.0296 22.6923 96.2707 23.6125C95.7283 23.6032 95.4131 23.5985 94.9496 23.5939C95.135 22.7248 93.5544 22.4414 94.1709 21.1401Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M228.193 23.8308C228.179 24.7603 228.17 25.5085 228.16 26.2939C227.919 26.3078 227.729 26.3171 227.456 26.3357C227.46 25.9686 227.465 25.6433 227.47 25.3365C227.117 25.146 226.774 25.0531 226.575 24.83C226.38 24.6116 226.339 24.2584 226.223 23.947C226.39 23.7844 226.589 23.5892 226.909 23.2778C227.321 23.4544 227.794 23.6589 228.193 23.8308Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M129.312 60.2883C129.071 59.5261 129.001 58.8197 129.752 58.2714C130.499 58.4387 131.249 58.606 132.186 58.8151C132.014 59.0614 131.917 59.3867 131.718 59.4703C130.944 59.7771 130.137 60.0141 129.312 60.2883Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M44.2855 79.2164C44.5543 79.4953 44.7444 79.6904 44.9483 79.8996C44.9437 80.3457 44.9344 80.8058 44.9252 81.4239C44.4755 81.5912 44.0027 81.7631 43.377 81.9955C43.3862 81.1543 43.3955 80.5084 43.4094 79.7602C43.6597 79.6068 43.9842 79.407 44.2855 79.2164Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M203.18 19.1791C204.576 19.523 204.423 20.6429 205.085 21.4004C204.538 21.814 204.191 22.0743 203.523 22.5762C203.778 21.2331 202.99 20.3362 203.18 19.1791Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M135.338 57.4024C136.001 56.7471 136.664 56.0919 137.447 55.3158C137.581 55.6179 137.716 55.9106 137.961 56.4544C137.813 56.8912 137.025 57.263 136.613 57.8067C136.2 57.8021 135.876 57.7974 135.551 57.7928C135.482 57.658 135.412 57.5279 135.338 57.4024Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M252.135 59.5215C252.144 58.7129 252.153 58.1041 252.163 57.5232C252.404 57.3048 252.603 57.1189 252.904 56.8494C253.215 57.1003 253.521 57.342 253.938 57.6766C253.326 58.2575 253.465 59.3914 252.135 59.5215Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M80.7562 10.8002C80.3854 10.5678 80.098 10.3912 79.9219 10.2843C79.9311 9.46176 80.4457 9.2294 81.9383 9.21545C81.929 9.72665 81.9243 10.2378 81.9151 10.8141C81.4747 10.8094 81.0158 10.8048 80.7562 10.8002Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M134.212 86.5451C134.207 87.0099 134.198 87.4746 134.193 87.9347C132.895 88.0555 132.895 88.0555 132.121 87.3445C132.45 86.1826 133.289 86.3128 134.212 86.5451Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M232.671 30.9272C232.569 31.0248 232.37 31.2154 232.087 31.4802C231.753 30.5787 230.423 30.7181 230.182 29.4634C230.682 29.3983 231.118 29.3472 231.651 29.2775C231.962 29.7747 232.277 30.2859 232.671 30.9272Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M57.7324 26.4147C58.2145 26.0151 58.5853 25.7084 58.9747 25.3877C59.225 25.5085 59.5541 25.6712 60.064 25.9221C59.9296 26.2893 59.8832 26.7819 59.619 27.0793C59.1138 27.6369 58.729 27.4929 57.7324 26.4147Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M131.936 8.87622C132.39 8.35573 132.835 7.96536 133.697 8.38361C133.498 9.14111 133.294 9.91255 133.034 10.8978C132.747 10.6422 132.478 10.5074 132.381 10.2936C132.195 9.8986 132.107 9.45712 131.936 8.87622Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M271.238 27.5765C271.544 27.4603 271.869 27.3302 272.193 27.2047C272.128 27.135 272.063 27.0653 271.998 26.9956",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M197.93 94.924C196.832 94.4128 197.045 93.6182 197.18 92.856C197.935 92.5121 198.501 92.87 198.732 93.423C198.983 94.0225 198.667 94.5941 197.93 94.924Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M185.943 85.6342C185.721 86.4103 185.494 87.1863 185.225 88.1158C184.956 87.9253 184.669 87.8277 184.599 87.6511C184.423 87.1817 184.339 86.6752 184.168 85.9734C184.585 85.7689 185.076 85.5273 185.568 85.2903C185.693 85.4018 185.818 85.518 185.943 85.6342Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M145.471 17.8035C145.346 17.5061 145.216 17.1854 145.082 16.8648C145.022 16.9252 144.961 16.9856 144.896 17.046C144.901 16.5859 144.91 16.1259 144.92 15.4613C145.411 15.6054 145.916 15.61 146.19 15.8656C146.848 16.4744 146.727 16.7811 145.471 17.8035Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M57.3379 84.1471C57.5697 83.5151 57.6299 83.0411 57.8941 82.7483C58.1166 82.502 58.5802 82.4695 58.9325 82.344C59.1735 82.8134 59.3682 83.1898 59.5536 83.5523C59.0483 84.3888 58.2928 84.0449 57.3379 84.1471Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M205.894 25.3413C205.885 25.8617 205.88 26.3683 205.871 27.005C205.287 26.7354 204.837 26.5263 204.234 26.2475C204.36 25.806 204.489 25.3366 204.652 24.7697C205.12 24.9881 205.407 25.1182 205.894 25.3413Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M234.882 66.4366C234.104 66.0973 233.793 65.6373 234.057 64.8054C234.169 64.7078 234.377 64.5266 234.581 64.35C234.892 64.5033 235.23 64.6706 235.578 64.8426C235.87 65.5397 235.513 65.9951 234.882 66.4366Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M23.7878 78.5565C23.0044 78.5472 22.5409 78.538 22.0078 78.5333C22.0171 77.9942 22.0217 77.483 22.031 76.7534C22.5455 76.9486 23.0276 77.009 23.315 77.2785C23.5607 77.5063 23.5885 77.9756 23.7878 78.5565Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M64.5376 35.9091C65.2839 36.569 65.7196 36.9547 66.058 37.2521C66.0533 37.6982 66.0487 38.0189 66.0394 38.4976C65.7057 38.3628 65.4878 38.2698 65.2746 38.1816C65.0428 38.084 64.8111 37.9864 64.5098 37.8655C64.519 37.3822 64.5237 36.8757 64.5376 35.9091Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M266.139 16.3675C266.143 15.9028 266.148 15.5775 266.153 15.2568C266.829 15.0941 267.358 14.3459 268.252 14.9129C267.979 15.8888 267.418 16.4558 266.139 16.3675Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M26.6337 90.4441C26.3973 90.2025 26.2027 89.998 25.8828 89.6727C26.0311 89.2684 26.2119 88.7897 26.3927 88.3018C26.8748 88.5341 27.2039 88.6968 27.584 88.878C27.8436 89.7331 27.5237 90.2536 26.6337 90.4441Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M66.6191 65.1771C67.1383 64.9866 67.4721 64.8611 67.8939 64.7078C67.9263 64.7264 68.2647 64.8936 68.6865 65.1028C68.6541 65.5768 68.617 66.0926 68.5521 66.9942C67.829 66.3111 67.3654 65.8742 66.6191 65.1771Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M93.5918 58.6804C93.3044 58.9592 93.1051 59.1544 92.8223 59.4286C92.2383 59.1125 91.6218 58.7826 90.8477 58.369C91.2138 58.0576 91.4549 57.8532 91.7701 57.5836C92.3727 57.9461 92.966 58.3039 93.5918 58.6804Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M173.168 57.1794C173.377 58.0159 173.173 58.5596 172.389 58.8105C171.615 58.5085 171.448 57.9508 171.629 57.1608C172.12 57.1654 172.584 57.1701 173.168 57.1794Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M231.319 52.4578C231.699 52.4624 231.972 52.4671 232.394 52.4717C232.417 52.9736 232.441 53.4802 232.468 54.0239C232.102 54.2516 231.778 54.4514 231.291 54.7581C231.3 53.8566 231.31 53.1548 231.319 52.4578Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M24.6406 36.5457C24.6499 35.9741 24.6545 35.514 24.6592 35.0354C25.4286 34.645 25.9107 35.0075 26.3186 35.6256C26.1193 36.4435 25.5955 36.6991 24.6406 36.5457Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M55.1648 66.4227C53.9921 66.3855 54.1636 65.391 53.4961 64.8798C53.7696 64.7729 54.0153 64.6753 54.4232 64.5127C54.4463 64.522 54.7755 64.666 55.1834 64.8426C55.1834 65.3167 55.1741 65.8371 55.1648 66.4227Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M131.926 19.0861C131.935 18.482 131.94 17.9754 131.949 17.269C132.426 17.5804 132.746 17.7849 132.997 17.9475C132.987 18.5517 132.983 19.0582 132.973 19.7646C132.491 19.4579 132.176 19.2488 131.926 19.0861Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M139.603 8.91797C139.112 8.51366 138.852 8.29989 138.5 8.00247C138.838 7.60746 139.093 7.31003 139.427 6.92432C139.775 7.18921 140.09 7.42622 140.507 7.74687C140.21 8.12794 139.946 8.47184 139.603 8.91797Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M112.787 14.5783C112.277 14.6248 111.953 14.6526 111.573 14.6852C111.346 14.2344 111.118 13.7883 110.812 13.1795C111.091 13.0168 111.383 12.8449 111.628 12.7008C111.934 13.1934 112.31 13.8022 112.787 14.5783Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M192.766 85.044C192.363 85.5366 192.145 85.7969 191.853 86.1501C191.459 85.8108 191.162 85.5552 190.777 85.2206C191.042 84.8721 191.278 84.5607 191.598 84.1378C191.978 84.4352 192.326 84.7001 192.766 85.044Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M163.761 91.9266C163.52 91.4154 163.298 90.9507 163.08 90.486C163.321 90.235 163.516 90.0398 163.724 89.826C164.114 90.3977 164.498 90.9553 165.004 91.6942C164.485 91.7918 164.123 91.8569 163.761 91.9266Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M157.458 2.70471C157.634 2.88595 157.82 3.08114 158.098 3.35997C157.884 3.8154 157.653 4.308 157.435 4.76808C157.236 4.76343 157.106 4.76343 156.846 4.75878C156.758 3.9827 156.573 3.21591 157.458 2.70471Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M98.6775 14.1275C97.5974 13.8766 97.3935 13.3189 97.5511 12.4173C97.8941 12.3987 98.2649 12.3848 98.7006 12.3616C98.6914 12.9704 98.6867 13.4815 98.6775 14.1275Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M209.074 82.0465C209.046 81.4982 209.018 80.9916 208.99 80.5408C209.245 80.2945 209.435 80.104 209.579 79.9692C209.838 80.1644 210.103 80.3596 210.432 80.6059C209.899 81.0799 210.075 81.9443 209.074 82.0465Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M140.311 39.8359C140.306 40.3192 140.302 40.6399 140.293 41.0256C139.44 41.2626 138.879 41.0303 138.582 39.9475C139.189 39.9056 139.727 39.8731 140.311 39.8359Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M149.772 89.6169C150.194 89.6216 150.518 89.6262 150.917 89.6309C150.908 90.17 150.903 90.6812 150.894 91.2992C149.902 91.1877 149.628 90.644 149.772 89.6169Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M247.889 27.0979C248.385 27.5766 248.658 27.8461 249.275 28.4456C248.533 28.6361 248.106 28.743 247.685 28.8499C247.745 28.9847 247.81 29.1194 247.87 29.2496C247.624 29.0358 247.379 28.8174 247.119 28.5897C247.323 28.2039 247.518 27.8275 247.889 27.0979Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M179.054 64.8286C178.85 64.2942 178.669 63.8109 178.502 63.3694C179.304 62.7745 179.772 63.1463 180.138 63.5646C179.814 63.941 179.489 64.3221 179.054 64.8286Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M35.9827 32.7303C35.978 33.0092 35.9734 33.2787 35.9688 33.697C35.6165 33.7295 35.2503 33.7574 34.9305 33.7853C34.6848 33.5343 34.4947 33.3391 34.3047 33.1439C34.7729 32.6188 35.2503 32.1355 35.9827 32.7303Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M155.424 12.6869C154.812 13.4304 154.538 13.7558 154.149 14.2298C153.755 13.765 153.477 13.4444 152.967 12.8449C153.815 12.7891 154.348 12.7566 155.424 12.6869Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M82.9674 25.3877C82.3462 25.1321 81.8827 24.9462 81.0391 24.5976C81.8688 24.2119 82.3416 23.9888 82.9952 23.6821C82.9813 24.3513 82.9767 24.7696 82.9674 25.3877Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M154.367 78.1615C154.024 77.339 153.852 76.9207 153.662 76.4607C153.843 76.2655 154.028 76.0703 154.39 75.6799C154.506 76.0099 154.617 76.3166 154.728 76.628C154.849 76.5768 154.974 76.5257 155.094 76.47C154.886 76.9486 154.682 77.4226 154.367 78.1615Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M205.17 90.0212C206.176 90.0352 206.681 90.0398 207.427 90.0538C207.043 90.5743 206.792 90.9182 206.426 91.4154C206.018 90.9646 205.703 90.6114 205.17 90.0212Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M115.647 13.8719C116.022 13.8766 116.296 13.8812 116.708 13.8859C116.736 14.2484 116.764 14.6201 116.801 15.0756C116.388 15.0709 116.069 15.0663 115.633 15.0616C115.633 14.7131 115.637 14.2948 115.647 13.8719Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M79.1894 88.9895C78.7954 88.9848 78.4663 88.9802 78.0723 88.9755C78.0769 88.6177 78.0815 88.297 78.0862 87.823C78.3782 87.8044 78.7537 87.7765 79.2033 87.744C79.2033 88.1576 79.1987 88.4783 79.1894 88.9895Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M61.3158 52.5926C60.9682 52.5879 60.7827 52.5833 60.5695 52.5833C60.4165 51.8118 60.2636 51.0822 61.1675 50.5199C61.4456 51.2263 61.2648 51.8955 61.3158 52.5926Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M168.926 92.3309C168.523 92.3262 168.199 92.3216 167.805 92.317C167.809 91.9545 167.814 91.6292 167.819 91.1644C168.115 91.1459 168.491 91.1226 168.94 91.0901C168.936 91.5037 168.931 91.829 168.926 92.3309Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M236.346 74.7923C235.939 73.9465 235.697 73.4539 235.299 72.6221C235.911 72.8358 236.282 72.8637 236.499 73.0636C236.852 73.3842 236.81 73.426 236.346 74.7923Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M170.882 11.5437C170.321 12.0921 170.117 12.2826 169.886 12.5103C169.668 12.2733 169.45 12.041 169.135 11.7017C169.399 11.395 169.645 11.1115 169.686 11.0651C170.062 11.2184 170.396 11.3532 170.882 11.5437Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M221.18 88.7385C221.671 88.5712 222.019 88.455 222.278 88.3667C222.278 88.3667 222.547 88.5665 222.918 88.8407C222.631 89.1707 222.417 89.4123 222.116 89.7562C221.852 89.4727 221.611 89.2125 221.18 88.7385Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M184.311 77.246C184.635 77.4272 184.941 77.5945 185.651 77.9895C185.006 78.2033 184.663 78.3148 184.237 78.4543C184.265 78.4868 184.07 78.2358 183.787 77.8687C184.014 77.6038 184.255 77.311 184.311 77.246Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M132.275 1.5057C132.001 1.20363 131.816 1.0038 131.547 0.706377C131.793 0.39966 132.034 0.0975915 132.112 0C132.442 0.162652 132.761 0.316011 133.211 0.53443C132.798 0.961973 132.571 1.19898 132.275 1.5057Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M218.097 25.2298C217.536 25.7781 217.332 25.9687 217.101 26.1964C216.883 25.9594 216.665 25.727 216.35 25.3878C216.614 25.0811 216.86 24.7976 216.901 24.7511C217.277 24.8998 217.61 25.0346 218.097 25.2298Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M116.657 74.4716C116.124 73.7141 115.86 73.3423 115.572 72.9334C115.748 72.7521 115.929 72.5709 116.105 72.3896C116.509 72.3199 116.731 72.9101 116.657 74.4716Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M194.889 2.70935C194.921 3.13225 194.949 3.50402 194.986 3.95945C194.532 3.9548 194.161 3.95016 193.813 3.94551C193.545 3.40179 193.6 3.33672 194.889 2.70935Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M269.94 68.579C269.078 68.5186 268.712 68.4907 268.137 68.4489C268.443 67.9516 268.637 67.6356 268.925 67.1755C269.226 67.5938 269.462 67.9191 269.94 68.579Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M215.947 67.0221C215.887 67.8865 215.859 68.2583 215.817 68.8252C215.321 68.5185 215.006 68.3233 214.547 68.0352C214.964 67.7331 215.284 67.5008 215.947 67.0221Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M94.6261 72.5291C94.334 72.2875 94.0374 72.0458 93.7129 71.7809C94.0466 71.5253 94.3433 71.293 94.8532 70.8979C94.9366 71.5393 94.9876 71.9343 95.0386 72.3293C94.8996 72.399 94.7605 72.4641 94.6261 72.5291Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M225.33 76.3862C225.566 76.0888 225.798 75.7914 226.062 75.4568C226.327 75.7867 226.558 76.0795 226.966 76.5814C226.322 76.6697 225.933 76.7255 225.539 76.7766C225.465 76.6465 225.395 76.5163 225.33 76.3862Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M192.923 79.3604C192.617 78.9654 192.385 78.6633 191.996 78.1568C192.636 78.0731 193.03 78.022 193.734 77.9337C193.373 78.5657 193.169 78.9329 192.923 79.3604Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M140.693 2.13775C140.396 1.73809 140.169 1.43137 139.789 0.924823C140.419 0.850467 140.818 0.803995 141.532 0.715698C141.156 1.35237 140.943 1.7102 140.693 2.13775Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M97.657 19.1093C97.4484 18.8909 97.2584 18.7004 96.9941 18.4262C97.3464 18.1892 97.6802 17.9615 98.2132 17.6036C98.2411 18.2171 98.255 18.5842 98.2735 19.0024C98.0093 19.0489 97.8239 19.0814 97.657 19.1093Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M219.822 21.8093C220.457 22.1858 220.814 22.3995 221.241 22.6505C220.837 22.9479 220.536 23.1756 220.031 23.552C219.952 22.92 219.906 22.525 219.822 21.8093Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M119.832 47.7687C119.313 48.08 118.998 48.2706 118.516 48.5587C118.525 47.9499 118.53 47.5316 118.539 46.9182C119.016 47.2342 119.331 47.4433 119.832 47.7687Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M153.916 52.4252C153.438 52.1092 153.123 51.9047 152.688 51.6166C153.105 51.3285 153.434 51.0961 153.939 50.7476C153.93 51.3935 153.925 51.8118 153.916 52.4252Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M164.568 55.5435C165.046 55.8595 165.361 56.0639 165.796 56.3521C165.379 56.6402 165.05 56.8726 164.545 57.2211C164.554 56.5705 164.563 56.1569 164.568 55.5435Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M171.318 61.6127C171.634 61.1341 171.838 60.8181 172.125 60.3859C172.417 60.8041 172.644 61.1341 172.992 61.636C172.347 61.6267 171.93 61.6174 171.318 61.6127Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M221.997 22.3392C221.904 22.1626 221.705 21.8001 221.26 20.9868C222.071 21.3539 222.428 21.5166 223.109 21.8233C222.599 22.0603 222.312 22.1951 221.997 22.3392Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M95.8492 67.4404C95.4691 67.1105 95.2698 66.9432 94.9824 66.6922C95.4274 66.4599 95.789 66.274 96.6048 65.8511C96.2201 66.6643 96.0486 67.0222 95.8492 67.4404Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M235.949 10.1402C235.944 10.4004 235.944 10.5863 235.94 10.8326C235.527 10.828 235.156 10.8233 234.758 10.814C234.762 10.5538 234.762 10.3679 234.767 10.1216C235.18 10.1309 235.55 10.1355 235.949 10.1402Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M120.682 8.36499C120.566 8.15122 120.371 7.78409 119.936 6.97083C120.747 7.34725 121.104 7.5099 121.757 7.81197C121.275 8.06292 120.997 8.20234 120.682 8.36499Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M24.4467 14.7874C24.4421 15.0337 24.4421 15.2242 24.4375 15.4798C24.0388 15.4752 23.6634 15.4706 23.223 15.4613C23.2045 14.2902 23.9322 14.8153 24.4467 14.7874Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M240.019 72.7289C239.843 72.8218 239.481 73.0216 238.67 73.4631C239.036 72.6499 239.198 72.292 239.504 71.6089C239.741 72.1294 239.87 72.4129 240.019 72.7289Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M123.736 74.9875C123.652 74.6064 123.564 74.2207 123.467 73.7746C123.763 73.7188 123.954 73.6816 124.259 73.6259C124.255 74.0952 124.246 74.5181 124.241 74.9364C124.069 74.955 123.903 74.9689 123.736 74.9875Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M102.659 75.9959C102.335 75.7589 102.01 75.5172 101.672 75.2709C101.936 75.0107 102.131 74.8248 102.39 74.5692C102.604 74.9549 102.808 75.3174 103.007 75.6799C102.891 75.7868 102.775 75.8937 102.659 75.9959Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M88.7021 79.1049C88.9617 79.1095 89.1471 79.1095 89.3975 79.1142C89.3928 79.5278 89.3882 79.8995 89.3789 80.2992C89.1193 80.2945 88.9339 80.2945 88.6836 80.2899C88.6882 79.8809 88.6975 79.5092 88.7021 79.1049Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M109.265 40.203C109.255 40.7374 109.251 41.0627 109.246 41.4392C109.033 41.4763 108.843 41.5135 108.518 41.5693C108.49 41.151 108.467 40.7793 108.439 40.3517C108.708 40.3006 108.894 40.2681 109.265 40.203Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M56.2132 39.8964C56.2967 40.2774 56.3848 40.6632 56.4821 41.1093C56.1808 41.1651 55.9954 41.2022 55.6895 41.258C55.6941 40.7886 55.7034 40.3657 55.708 39.9475C55.8795 39.9289 56.0464 39.9103 56.2132 39.8964Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M172.884 85.5506C172.791 85.374 172.591 85.0115 172.146 84.1982C172.958 84.5654 173.315 84.728 173.996 85.0347C173.486 85.2717 173.199 85.4065 172.884 85.5506Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M74.4707 13.0168C74.4753 12.566 74.48 12.3755 74.4846 12.1152C74.8833 12.1199 75.2541 12.1245 75.6759 12.1338C75.7501 13.3746 74.9342 12.6683 74.4707 13.0168Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M127.972 90.0862C127.439 90.0769 127.115 90.0723 126.739 90.0676C126.702 89.8539 126.665 89.6633 126.609 89.338C127.027 89.3102 127.402 89.2869 127.824 89.259C127.875 89.5239 127.907 89.7145 127.972 90.0862Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M222.567 90.9181C222.873 91.1179 223.184 91.3224 223.708 91.6617C223.323 91.8475 223.045 91.987 222.795 92.1078C222.651 91.8847 221.9 91.657 222.567 90.9181Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M72.8398 90.6207C72.6034 90.6161 72.4643 90.6161 72.1909 90.6114C72.163 90.2489 72.1352 89.8771 72.1074 89.4496C72.367 89.3985 72.557 89.366 72.8583 89.3055C72.8491 89.7796 72.8444 90.1978 72.8398 90.6207Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M48.741 56.8728C48.7473 56.416 48.5283 56.0425 48.2519 56.0387C47.9754 56.0349 47.7462 56.4021 47.7399 56.8589C47.7336 57.3157 47.9526 57.6891 48.2291 57.693C48.5055 57.6968 48.7348 57.3296 48.741 56.8728Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M171.323 14.4297C171.128 14.6202 170.938 14.8061 170.669 15.0663C170.428 14.7224 170.197 14.3925 169.965 14.0625C170.744 13.4119 170.948 14.1648 171.323 14.4297Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M226.294 32.01C226.377 32.4236 226.423 32.656 226.488 32.9813C226.015 32.9766 225.645 32.9673 224.986 32.9627C225.515 32.5723 225.839 32.34 226.294 32.01Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M26.8662 32.2145C27.2278 32.6838 27.4595 32.9906 27.7886 33.4228C27.4085 33.5668 27.1907 33.6458 26.8477 33.7759C26.8523 33.2369 26.8616 32.8186 26.8662 32.2145Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M183.825 39.7337C183.394 39.9149 183.176 40.0032 182.81 40.1519C182.772 39.6593 182.745 39.2875 182.717 38.9157C183.384 38.8507 183.375 39.3805 183.825 39.7337Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M127.258 46.1887C127.059 46.3839 126.859 46.5791 126.632 46.7975C126.442 46.6163 126.257 46.435 125.928 46.119C126.183 45.9378 126.428 45.7658 126.674 45.5939C126.869 45.7844 127.063 45.9842 127.258 46.1887Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M151.998 9.12708C152.281 8.95513 152.564 8.78783 152.888 8.59265C152.902 8.87613 152.92 9.24791 152.948 9.81952C152.559 9.71263 152.304 9.64757 152.054 9.57786C152.035 9.42915 152.017 9.28044 151.998 9.12708Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M267.659 81.7445C267.65 82.4091 267.645 82.7808 267.641 83.2549C267.325 83.1898 267.089 83.148 266.672 83.0643C267.01 82.6042 267.251 82.2836 267.659 81.7445Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M239.893 17.3388C239.327 17.7291 238.998 17.9569 238.52 18.2868C238.46 17.8546 238.428 17.6223 238.391 17.3202C238.859 17.3248 239.23 17.3341 239.893 17.3388Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M205.095 85.5042C205.085 86.1687 205.081 86.5405 205.076 87.0145C204.761 86.9494 204.525 86.9076 204.107 86.824C204.45 86.3639 204.691 86.0432 205.095 85.5042Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M163.359 67.1709C163.479 67.2917 163.674 67.4962 163.892 67.7193C163.683 67.8959 163.475 68.0771 163.229 68.2862C163.071 68.1375 162.886 67.9609 162.543 67.6356C162.821 67.473 163.09 67.3243 163.359 67.1709Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M189.137 9.03882C189.892 9.04811 190.217 9.05276 190.833 9.06205C190.467 9.43848 190.245 9.66619 189.888 10.0333C189.661 9.7359 189.498 9.51748 189.137 9.03882Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M198.342 60.5253C198.333 61.2828 198.328 61.6034 198.319 62.2215C197.948 61.859 197.712 61.6267 197.346 61.2735C197.647 61.0504 197.865 60.8878 198.342 60.5253Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M29.7578 13.2538C30.1796 13.1841 30.4114 13.1423 30.7312 13.0865C30.7266 13.5606 30.722 13.9277 30.7127 14.5969C30.3187 14.0439 30.0869 13.7186 29.7578 13.2538Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M183.494 72.6592C183.485 73.2773 183.481 73.5979 183.476 73.9418C182.92 73.5282 182.92 73.5282 182.623 73.0031C182.855 72.9148 183.073 72.8265 183.494 72.6592Z",
    fill: "#B8AC97"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M6.89566 169.777C6.993 169.818 7.28967 169.944 7.5817 170.074C7.79492 170.548 7.59097 171.264 7.1367 171.487C6.35332 171.868 5.88515 171.473 5.39844 170.604C5.86661 170.344 6.34869 170.074 6.89566 169.777Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M5.17578 102.304C6.24655 102.318 6.75181 102.327 7.47492 102.336C7.18289 102.843 6.96967 103.205 6.65446 103.754C6.2141 103.321 5.87572 102.991 5.17578 102.304Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M0.0957031 126.441C0.410908 125.963 0.614864 125.647 0.902257 125.214C1.19429 125.633 1.42142 125.963 1.76907 126.465C1.12475 126.455 0.707572 126.446 0.0957031 126.441Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M4.69922 130.596C5.21838 130.285 5.53822 130.094 6.01566 129.806C6.00639 130.415 6.00176 130.833 5.99249 131.446C5.51504 131.13 5.19984 130.926 4.69922 130.596Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M4.07705 184.123C4.06778 184.657 4.06314 184.982 4.05851 185.359C3.84528 185.396 3.65523 185.433 3.33075 185.489C3.30294 185.071 3.27977 184.699 3.25195 184.271C3.5208 184.22 3.71085 184.188 4.07705 184.123Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M5.22228 98.1259C5.21765 98.4977 5.21301 98.8694 5.20838 99.2598C4.9488 99.2552 4.76338 99.2552 4.35547 99.2459C4.5826 98.7672 4.75875 98.4001 4.93025 98.0376C5.02296 98.0655 5.12494 98.0934 5.22228 98.1259Z",
    fill: "#B8AC97"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M12.7439 158.024C13.2028 157.88 13.657 157.736 14.2365 157.554C14.014 156.774 13.8425 156.174 13.6663 155.556C13.8795 155.37 14.102 155.17 14.3431 154.961C15.4927 155.538 16.1741 156.481 16.3919 157.759C15.3443 158.851 14.4033 159.999 12.7207 159.822C12.7253 159.218 12.7346 158.619 12.7439 158.024Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M82.1801 62.8768C81.4941 64.0758 80.414 64.2942 79.0234 64.1362C79.0281 63.6715 79.0373 63.2532 79.042 62.8303C80.0896 62.8443 81.1372 62.8629 82.1801 62.8768Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M12.4555 178.676C12.6734 178.681 12.8913 178.681 13.1555 178.685C13.568 179.541 13.378 180.154 12.4277 180.47C12.4416 179.875 12.4509 179.276 12.4555 178.676Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M13.6279 93.3672C13.8504 93.3718 14.0683 93.3718 14.4391 93.3765C14.4669 93.7668 14.4947 94.1665 14.5364 94.7242C14.161 94.7195 13.8875 94.7149 13.6094 94.7102C13.6186 94.2641 13.6233 93.8133 13.6279 93.3672Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M219.481 178.095C219.467 178.969 219.462 179.545 219.453 180.205C218.276 179.977 217.186 179.763 215.856 179.508C215.74 179.145 215.569 178.634 215.43 178.211C216.361 177.249 217.312 176.859 218.475 177.063C218.827 177.421 219.189 177.798 219.481 178.095Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M168.51 137.609C169.585 136.87 170.656 136.131 171.643 135.448C172.839 135.922 172.612 136.782 172.58 137.437C172 138.055 171.495 138.594 171.041 139.082C169.715 139.37 169.511 137.892 168.51 137.609Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M58.6006 204.947C58.8556 204.951 59.2867 204.956 59.8197 204.965C60.2276 205.449 60.6958 206.002 61.1454 206.531C58.8231 208.014 58.8231 208.014 57.5067 208C57.4557 207.949 57.3583 207.893 57.3583 207.842C57.3537 207.256 57.3676 206.666 57.3769 205.969C57.6967 205.7 58.0907 205.37 58.6006 204.947Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M245.169 173.141C245.165 173.587 245.155 174.034 245.151 174.545C244.965 174.591 244.771 174.684 244.571 174.693C243.403 174.735 243.348 173.913 243.334 172.904C242.638 172.895 241.925 172.886 241.188 172.876C241.197 172.37 241.201 172.017 241.206 171.631C242.967 171.013 243.867 172.621 245.169 173.141Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M229.098 103.322C229.093 103.758 229.084 104.205 229.08 104.776C228.82 104.804 228.542 104.892 228.278 104.855C227.323 104.72 227.198 104.028 227.36 103.075C226.567 103.066 225.863 103.057 225.163 103.043C225.153 101.662 225.265 101.486 226.201 101.714C226.79 101.858 227.337 102.206 227.874 102.508C228.296 102.741 228.685 103.043 229.098 103.322Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M156.843 84.0263C156.76 83.9194 156.542 83.6359 156.227 83.2269C156.607 82.7948 157.019 82.33 157.58 81.6887C157.877 82.1534 158.113 82.5252 158.359 82.9063C159.263 82.66 159.675 81.3448 160.728 82.0884C160.426 82.9435 160.426 82.9435 159.81 83.5662C158.85 83.7149 157.951 83.8543 156.843 84.0263Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M198.695 163.419C198.705 162.731 198.709 162.439 198.714 162.146C199.154 161.928 199.59 161.714 200.104 161.458C200.656 161.797 201.249 162.165 201.782 162.494C201.773 163.113 201.769 163.614 201.759 164.075C200.401 164.906 200.072 162.601 198.695 163.419Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M34.2099 206.452C33.6954 205.179 34.6178 204.812 35.1184 204.185C35.6005 204.189 36.0965 204.199 36.7732 204.208C36.9494 204.663 37.1441 205.174 37.3109 205.621C36.9726 205.951 36.7593 206.16 36.5183 206.397C35.7813 205.351 35.0257 206.276 34.2099 206.452Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M50.0488 199.923C50.6236 199.891 50.9713 199.872 51.4163 199.849C51.6527 200.155 51.9215 200.504 52.1904 200.848C52.9228 200.857 53.5717 200.866 54.1975 200.876C54.2346 201.09 54.2624 201.224 54.3087 201.48C53.5578 201.712 52.793 201.949 52.3155 202.098C51.5553 201.373 50.9435 200.787 50.0488 199.923Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M177.446 142.683C176.862 142.883 176.357 143.06 175.778 143.255C175.717 142.958 175.676 142.753 175.602 142.405C176.57 142.177 177.516 141.958 178.457 141.74C178.967 142.321 179.384 142.79 179.88 143.357C179.56 143.529 179.403 143.65 179.226 143.701C178.392 143.938 178.151 143.097 177.446 142.683Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M268.393 165.669C268.227 165.195 268.06 164.307 267.893 164.307C266.989 164.307 267.429 163.266 266.836 163.117C267.897 162.285 267.897 162.285 268.954 163.029C268.94 163.903 268.931 164.758 268.917 165.613C268.746 165.627 268.57 165.65 268.393 165.669Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M96.9766 118.922C97.5792 118.058 98.0983 117.314 98.7519 116.375C99.0578 117.533 98.8168 118.518 98.8956 119.457C98.6499 119.694 98.4413 119.903 98.3254 120.014C97.8805 119.656 97.4355 119.299 96.9766 118.922Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M235.445 150.584C236.266 150.319 236.905 150.11 237.633 149.877C237.842 150.11 238.148 150.337 238.291 150.639C238.403 150.876 238.305 151.206 238.301 151.653C237.286 151.639 236.206 152.085 235.445 150.584Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M183.408 206.118C183.167 205.793 182.968 205.518 182.699 205.156C183.455 204.872 184.067 204.645 184.725 204.403C185.499 204.705 185.684 205.295 185.494 206.15C184.836 206.137 184.196 206.127 183.408 206.118Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M244.4 203.692C244.817 204.245 245.165 204.71 245.61 205.305C245.476 205.472 245.281 205.946 244.947 206.085C244.488 206.276 243.955 206.188 243.598 205.676C243.01 204.826 243.51 204.343 244.4 203.692Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M221.686 80.0575C221.9 80.5129 222.145 81.0427 222.484 81.7723C221.529 81.7584 220.838 81.7491 220.147 81.7398C220.226 81.6747 220.31 81.6097 220.389 81.5446C220.059 81.3866 219.73 81.2286 219.471 81.1031C219.596 80.8103 219.624 80.6012 219.707 80.578C220.291 80.4014 220.884 80.262 221.686 80.0575Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M89.2917 64.9633C88.9024 65.3723 88.5501 65.7441 88.2117 66.0973C87.4051 65.4978 86.5847 64.954 85.8477 63.7225C87.1965 64.0897 88.0495 64.3127 88.8885 64.5637C89.0182 64.6009 89.1017 64.7682 89.2917 64.9633Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M273 170.822C272.268 170.218 271.401 169.261 271.248 168.861C271.772 168.871 272.263 168.875 272.611 168.88",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M25.1427 186.033C25.3096 186.042 25.4579 186.051 25.7036 186.065C25.6943 186.702 25.685 187.343 25.6758 188.18C25.4394 188.37 25.0361 188.695 24.5077 189.118C24.3871 188.951 24.1924 188.682 23.9375 188.328C24.3176 187.603 24.7302 186.813 25.1427 186.033Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M199.645 127.533C199.404 128.951 199.404 128.951 198.18 129.132C197.842 128.881 197.554 128.663 197.146 128.361C197.642 127.817 198.023 127.399 198.403 126.985C198.778 127.152 199.135 127.306 199.645 127.533Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M58.3969 107.383C57.8499 108.168 57.3076 108.959 56.7467 109.767C56.2878 109.293 55.9309 108.926 55.5508 108.536C56.2971 107.839 57.1407 107.327 58.0678 106.965C58.179 107.104 58.2903 107.244 58.3969 107.383Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M104.926 137.678C104.903 137.962 104.88 138.245 104.852 138.589C104.509 138.608 104.226 138.622 104.036 138.631C103.513 138.162 103.044 137.739 102.377 137.135C102.78 136.749 103.072 136.465 103.693 135.866C104.023 136.702 104.25 137.274 104.477 137.846C104.625 137.79 104.773 137.734 104.926 137.678Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M23.2227 194.277C23.0975 193.952 22.9631 193.598 22.8287 193.25C22.7545 193.32 22.6757 193.389 22.6016 193.459C22.6062 192.966 22.6155 192.474 22.6247 191.767C23.1393 191.911 23.6816 191.911 23.9783 192.176C24.6921 192.822 24.5623 193.152 23.2227 194.277Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M132.92 121.65C133.013 121.469 133.23 121.041 133.49 120.535C133.991 121.023 134.389 121.408 134.853 121.859C134.644 122.361 134.459 122.798 134.329 123.105C133.93 122.691 133.555 122.305 132.92 121.65Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M179.249 94.4453C178.66 95.2911 178.229 95.9092 177.719 96.6435C177.385 96.3832 177.056 96.1276 176.648 95.8116C177.158 94.8729 177.659 94.055 179.249 94.4453Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M48.658 94.0038C49.1401 93.7854 49.6268 93.567 50.2943 93.2649C50.3267 93.9527 50.3499 94.4964 50.3777 95.0401C50.2804 94.9658 50.1877 94.8914 50.0903 94.8171C49.9188 95.1377 49.7473 95.4537 49.6082 95.7186C48.7414 95.4351 48.4401 94.9518 48.658 94.0038Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M61.2986 198.696C60.9092 198.297 60.5523 197.925 60.2324 197.595C60.6033 197.172 60.9741 196.749 61.433 196.224C61.8316 196.577 62.1376 196.847 62.5594 197.218C62.119 197.734 61.7111 198.213 61.2986 198.696Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M63.0731 98.7301C63.5969 100.194 63.0036 100.961 62.5076 101.76C62.35 101.737 62.1971 101.714 62.0395 101.69C61.9931 101.021 61.9467 100.352 61.9004 99.6595C62.248 99.3854 62.5679 99.1298 63.0731 98.7301Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M182.625 182.152C181.976 182.84 181.54 183.3 181.007 183.862C180.631 183.542 180.321 183.272 179.982 182.984C180.376 181.674 181.266 181.79 182.625 182.152Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M271.801 89.0778C272.292 89.5518 272.552 89.8027 272.936 90.1745C272.399 90.6996 271.912 91.1783 271.147 91.9312C271.064 91.0993 270.906 90.616 271.003 90.1931C271.082 89.8306 271.458 89.5332 271.801 89.0778Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M258.301 125.447C257.883 125.442 257.536 125.438 257.109 125.428C257.119 124.699 257.128 124.002 257.137 123.263C257.554 123.267 257.902 123.272 258.328 123.281C258.319 124.011 258.31 124.708 258.301 125.447Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M170.643 191.261C169.692 190.903 169.474 190.327 169.739 189.453C170.263 189.462 170.805 189.467 171.319 189.476C171.704 190.41 171.166 190.824 170.643 191.261Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M206.344 65.075C206.96 65.0842 207.451 65.0889 207.947 65.0982C208.369 65.9393 208.022 66.4645 207.28 66.8641C206.432 66.6597 206.186 66.0788 206.344 65.075Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M237.363 165.659C239.25 165.799 239.25 165.799 239.454 167.421C238.958 167.342 238.411 167.402 238.114 167.16C237.78 166.895 237.683 166.347 237.363 165.659Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M51.0918 142.358C51.1011 141.74 51.1057 141.247 51.115 140.75C51.954 140.327 52.4778 140.676 52.8764 141.419C52.6725 142.265 52.093 142.516 51.0918 142.358Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M258.385 171.324C259.015 170.715 259.391 170.353 259.762 169.99C260.693 170.688 260.679 171.083 259.59 172.314C259.242 172.026 258.885 171.733 258.385 171.324Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M121.072 85.9735C121.772 86.6381 122.231 87.0749 122.672 87.4885C122.611 87.916 122.565 88.2553 122.496 88.7804C121.443 88.1438 120.558 87.679 121.072 85.9735Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M243.857 99.8872C244.149 100.7 244.311 101.156 244.469 101.593C244.145 101.941 243.903 102.202 243.574 102.564C243.171 102.229 242.856 101.965 242.406 101.588C242.851 101.072 243.259 100.589 243.857 99.8872Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M132.002 136.205C132.368 135.485 132.637 134.964 132.887 134.472C133.967 134.727 134.194 135.318 134.042 136.233C133.462 136.224 132.869 136.215 132.002 136.205Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M223.643 97.5682C221.757 97.4288 221.757 97.4288 221.553 95.8069C222.049 95.8859 222.596 95.8255 222.892 96.0671C223.221 96.332 223.319 96.8804 223.643 97.5682Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M222.42 134.913C223.018 134.923 223.509 134.927 224.024 134.936C224.469 135.754 224.075 136.266 223.37 136.698C222.545 136.493 222.253 135.945 222.42 134.913Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M167.689 145.825C168.644 145.839 169.136 145.844 169.71 145.853C169.706 146.22 169.701 146.564 169.697 146.968C169.432 147.098 169.075 147.275 168.515 147.549C168.301 147.108 168.06 146.606 167.689 145.825Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M32.5968 99.1112C32.4207 99.3575 32.0267 99.9012 31.526 100.594C31.1413 100.222 30.8956 99.9802 30.7148 99.8036C31.2201 99.3203 31.7254 98.8323 32.3094 98.27C32.3187 98.3118 32.4114 98.5767 32.5968 99.1112Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M196.465 109.447C196.085 110.195 195.84 110.673 195.599 111.147C195.288 111.143 194.996 111.138 194.56 111.133C194.537 110.813 194.398 110.436 194.505 110.148C194.811 109.33 195.459 109.228 196.465 109.447Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M167.524 84.9C167.171 85.0765 166.814 85.2578 166.601 85.3647C166.216 85.0161 165.818 84.6583 165.424 84.3005C165.498 84.2261 165.711 84.0216 165.924 83.8125C166.754 83.6777 167.334 83.938 167.524 84.9Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M147.437 96.3368C147.131 95.5932 146.909 95.0541 146.682 94.515C147.613 94.055 148.137 94.3989 148.591 95.2168C148.466 95.3887 148.327 95.6211 148.146 95.8116C148.012 95.9557 147.827 96.0486 147.437 96.3368Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M77.9902 115.102C78.5511 115.53 78.9126 115.809 79.2927 116.101C78.9961 116.678 78.7504 117.152 78.514 117.607C78.3379 117.602 78.1942 117.602 77.9531 117.598C77.967 116.845 77.9763 116.101 77.9902 115.102Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M239.236 88.3249C239.334 86.8006 239.334 86.8006 240.854 86.6101C240.701 87.1724 240.557 87.7115 240.386 88.3435C240.089 88.3342 239.746 88.3296 239.236 88.3249Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M256.911 156.658C256.754 157.15 256.591 157.666 256.42 158.21C256.086 158.205 255.738 158.2 255.242 158.191C255.247 157.884 255.173 157.582 255.266 157.35C255.599 156.509 255.771 156.462 256.911 156.658Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M62.7353 181.292C62.6241 180.326 62.397 179.545 63.4121 178.908C63.6068 179.299 63.8988 179.666 63.9683 180.066C64.0796 180.777 63.5141 181 62.7353 181.292Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M159.986 104.037C158.882 103.703 158.567 103.164 158.813 102.174C159.137 102.155 159.536 102.132 160.009 102.109C159.999 102.75 159.995 103.298 159.986 104.037Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M48.9309 133.175C48.4859 132.659 48.217 132.348 47.8555 131.925C48.4117 131.618 48.8196 131.395 48.9633 131.316C49.3434 131.502 49.6864 131.665 50.1639 131.897C49.6772 132.404 49.3944 132.697 48.9309 133.175Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M49.3438 106.751C49.353 105.943 49.3577 105.599 49.3623 105.259C50.0761 104.836 50.5768 105.152 51.1608 105.868C50.6231 106.128 50.1271 106.37 49.3438 106.751Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M68.3252 75.7078C68.6218 75.7124 68.9138 75.7171 69.3542 75.7217C69.3866 76.0981 69.4191 76.4885 69.4469 76.8324C69.1781 77.0973 68.9695 77.2971 68.7609 77.5016C68.2093 77.0043 67.6901 76.4978 68.3252 75.7078Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M152.763 168.935C153.203 170.158 151.878 169.67 151.748 170.265C151.395 169.902 151.043 169.535 150.682 169.168C150.765 169.084 150.844 168.922 150.932 168.922C151.562 168.912 152.197 168.931 152.763 168.935Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M90.7699 126.135C90.1858 125.819 89.9865 125.749 89.8382 125.619C89.6342 125.447 89.4673 125.228 89.166 124.903C89.6527 124.522 90.0097 124.239 90.6215 123.76C90.6725 124.629 90.7096 125.205 90.7699 126.135Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M213.199 108.108C213.491 109.196 213.26 109.795 212.323 110.055C211.929 108.973 211.929 108.973 213.199 108.108Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M229.275 177.937C229.567 179.025 229.335 179.624 228.399 179.884C228 178.806 228 178.806 229.275 177.937Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M39.0664 92.0659C40.1557 91.7592 40.7398 92.0148 41.004 92.9443C39.91 93.33 39.91 93.33 39.0664 92.0659Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M40.25 178.829C41.4691 178.662 41.4691 178.662 42.0207 179.759C40.8016 179.931 40.8016 179.931 40.25 178.829Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M238.763 188.124C239.185 188.128 239.533 188.133 239.955 188.142C239.95 188.523 239.945 188.867 239.936 189.374C239.626 189.397 239.222 189.425 238.74 189.458C238.754 189.021 238.759 188.672 238.763 188.124Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M199.882 69.2621C200.212 69.527 200.318 69.6153 200.555 69.8058C200.142 70.2891 199.729 70.7724 199.312 71.265C199.076 71.0141 198.877 70.8003 198.668 70.5819C199.039 70.1776 199.419 69.764 199.882 69.2621Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M162.637 195.597C162.368 195.322 162.215 195.16 161.941 194.881C162.502 194.532 162.683 193.738 163.652 193.789C164 194.755 163.008 194.96 162.637 195.597Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M39.8312 198.259C39.7524 198.329 39.4094 198.617 38.9783 198.984C38.8115 198.682 38.6214 198.506 38.6492 198.366C38.7419 197.916 38.9088 197.483 39.1962 196.577C39.4929 197.363 39.6319 197.739 39.8312 198.259Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M223.922 118.346C223.917 118.778 223.913 119.127 223.904 119.545C223.519 119.54 223.171 119.536 222.671 119.526C222.652 119.21 222.624 118.811 222.592 118.323C223.041 118.337 223.389 118.341 223.922 118.346Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M110.049 123.667C110.313 123.402 110.512 123.198 110.851 122.858C111.217 123.207 111.578 123.555 112.061 124.016C111.152 124.583 110.605 124.336 110.049 123.667Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M157.371 142.623C158.117 142.567 158.511 142.539 158.845 142.516C159.109 142.79 159.313 142.995 159.415 143.106C159.216 143.399 159.021 143.692 158.72 144.138C158.256 143.613 157.923 143.241 157.371 142.623Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M214.836 140.429C215.156 140.062 215.522 139.644 215.897 139.217C216.134 139.309 216.324 139.388 216.713 139.542C216.236 140.104 215.828 140.583 215.364 141.127C215.16 140.852 214.984 140.625 214.836 140.429Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M111.078 158.958C111.384 159.232 111.597 159.423 111.95 159.739C111.565 160.129 111.217 160.487 110.907 160.803C110.197 160.454 110.276 160.022 111.078 158.958Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M151.386 69.6339C150.779 68.9647 150.435 68.5882 150.014 68.1235C151.557 67.8493 151.557 67.8493 151.386 69.6339Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M74.9039 112.514C75.1913 112.867 75.4787 113.22 75.9423 113.787C75.3026 113.889 74.9225 113.954 74.4219 114.038C74.4311 113.522 74.4358 113.071 74.4404 112.621C74.5934 112.583 74.751 112.546 74.9039 112.514Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M24.6367 165.789C25.2903 165.845 25.6889 165.878 26.4491 165.947C25.8697 166.561 25.5267 166.928 24.9427 167.551C24.8129 166.826 24.748 166.445 24.6367 165.789Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M57.6269 146.248C58.0904 146.689 58.3037 146.889 58.7023 147.266C58.3685 147.41 58.0533 147.549 57.5574 147.767C57.5017 147.726 57.1587 147.489 56.8574 147.275C57.0938 146.963 57.3024 146.68 57.6269 146.248Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M201.509 73.979C201.282 73.7467 201.083 73.5422 200.805 73.2494C201.18 72.9985 201.537 72.7568 202.107 72.3711C202.135 73.0217 202.154 73.4167 202.172 73.8629C201.889 73.914 201.69 73.9465 201.509 73.979Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M266.204 80.7546C266.139 81.6748 266.112 82.0698 266.065 82.6832C265.532 82.3533 265.198 82.1442 264.707 81.8421C265.152 81.5168 265.495 81.2705 266.204 80.7546Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M92.6475 81.3402C91.9429 81.8467 91.5489 82.1302 91.1131 82.4462C90.9834 82.1163 90.8582 81.9536 90.8953 81.8746C91.1734 81.3309 91.433 80.6942 92.6475 81.3402Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M118.866 168.582C118.551 168.327 118.24 168.066 117.893 167.783C118.249 167.509 118.569 167.258 119.112 166.84C119.2 167.523 119.255 167.946 119.306 168.369C119.158 168.438 119.014 168.513 118.866 168.582Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M254.713 90.2953C255.037 89.9793 255.246 89.7795 255.464 89.561C255.798 89.5657 256.145 89.5703 256.539 89.575C256.576 89.8073 256.609 90.0072 256.655 90.3185C256.015 90.3139 255.422 90.3046 254.713 90.2953Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M53.3205 116.557C52.894 116.877 52.5649 117.119 52.0272 117.523C51.9484 116.845 51.8974 116.422 51.8047 115.66C52.4815 116.06 52.8662 116.287 53.3205 116.557Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M94.2649 121.185C93.755 120.851 93.4167 120.628 92.9531 120.326C93.3981 120.014 93.7504 119.768 94.2881 119.396C94.2835 120.084 94.2742 120.53 94.2649 121.185Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M236.061 127.148C235.64 127.473 235.32 127.724 234.777 128.142C234.689 127.459 234.634 127.036 234.541 126.279C235.218 126.665 235.603 126.888 236.061 127.148Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M251.014 131.205C250.569 130.968 250.207 130.773 249.832 130.573C249.837 130.401 249.837 130.201 249.841 129.932C250.231 129.936 250.574 129.941 251.033 129.95C251.028 130.327 251.019 130.773 251.014 131.205Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M79.3804 133.547C79.3665 134.439 79.3618 134.932 79.3526 135.48C79.1393 135.527 78.94 135.569 78.7639 135.606C78.2864 135.178 78.3838 134.802 79.3804 133.547Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M218.299 144.04C217.618 143.636 217.237 143.408 216.783 143.139C217.21 142.818 217.539 142.576 218.076 142.172C218.155 142.851 218.206 143.278 218.299 144.04Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M229.052 206.927C228.741 206.671 228.426 206.415 228.078 206.127C228.435 205.853 228.755 205.602 229.297 205.184C229.385 205.867 229.441 206.29 229.492 206.713C229.348 206.787 229.2 206.857 229.052 206.927Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M71.5562 200.439C71.89 200.992 72.094 201.336 72.3999 201.847C71.7509 201.838 71.3059 201.833 70.6523 201.824C70.9861 201.313 71.204 200.973 71.5562 200.439Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M267.183 199.779C267.178 200.211 267.174 200.555 267.169 200.867C267.081 200.95 266.998 201.057 266.984 201.048C266.641 200.834 266.302 200.611 265.908 200.355C265.908 200.23 265.913 200.035 265.917 199.765C266.302 199.765 266.65 199.77 267.183 199.779Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M163.889 197.655C164.556 197.265 164.899 197.065 165.442 196.754C165.469 197.367 165.488 197.762 165.516 198.431C164.932 198.157 164.547 197.971 163.889 197.655Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M252.133 196.995C251.707 197.316 251.377 197.558 250.84 197.962C250.761 197.284 250.71 196.861 250.617 196.094C251.294 196.498 251.679 196.726 252.133 196.995Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M165.112 68.1049C165.39 68.1095 165.59 68.1095 165.854 68.1142C165.849 68.5556 165.845 68.9506 165.835 69.3782C165.557 69.3735 165.358 69.3735 165.094 69.3689C165.103 68.9274 165.108 68.5324 165.112 68.1049Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M136.98 69.4154C137.068 69.8197 137.161 70.2194 137.267 70.7073C136.948 70.7677 136.748 70.8049 136.424 70.8653C136.428 70.3634 136.438 69.9127 136.442 69.4619C136.623 69.4479 136.804 69.4293 136.98 69.4154Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M157.473 69.6803C157.877 70.0474 158.081 70.238 158.377 70.5075C157.923 70.7445 157.534 70.9536 156.662 71.4137C157.07 70.5447 157.251 70.159 157.473 69.6803Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M120.632 174.561C120.639 174.073 120.404 173.675 120.107 173.671C119.81 173.666 119.564 174.058 119.557 174.546C119.55 175.034 119.786 175.432 120.083 175.436C120.38 175.441 120.626 175.049 120.632 174.561Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M123.425 78.7749C123.041 78.5565 122.656 78.3427 122.211 78.0917C122.512 77.8315 122.725 77.6456 123.031 77.3854C123.268 77.7107 123.513 78.0592 123.764 78.4031C123.653 78.5286 123.541 78.6541 123.425 78.7749Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M260.211 85.3228C260.429 84.9371 260.642 84.556 260.892 84.1052C261.152 84.4073 261.337 84.6211 261.602 84.9231C261.277 85.1601 260.929 85.4064 260.586 85.6574C260.461 85.5459 260.336 85.4343 260.211 85.3228Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M261.476 200.311C261.483 199.823 261.248 199.425 260.951 199.42C260.654 199.416 260.408 199.808 260.401 200.296C260.394 200.784 260.629 201.182 260.926 201.186C261.223 201.19 261.469 200.798 261.476 200.311Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M119.569 185.921C119.972 186.288 120.176 186.479 120.473 186.748C120.019 186.99 119.629 187.194 118.758 187.654C119.166 186.785 119.347 186.4 119.569 185.921Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M245.226 131.103C244.948 131.098 244.749 131.098 244.484 131.093C244.489 130.652 244.494 130.252 244.503 129.829C244.781 129.834 244.98 129.834 245.245 129.839C245.235 130.275 245.231 130.675 245.226 131.103Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M18.8709 106.57C19.2371 107.309 19.4364 107.713 19.645 108.141C18.8895 108.522 18.6809 107.899 18.3008 107.383C18.4167 107.206 18.5557 107.016 18.8709 106.57Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M205.885 122.24C206.098 121.906 206.307 121.571 206.677 120.99C206.867 121.422 207.002 121.729 207.15 122.068C206.983 122.161 206.594 122.38 206.209 122.594C206.103 122.473 205.991 122.357 205.885 122.24Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M236.737 183.129C236.741 182.832 236.348 182.585 235.859 182.578C235.37 182.571 234.971 182.807 234.966 183.105C234.962 183.402 235.355 183.649 235.844 183.656C236.333 183.663 236.733 183.427 236.737 183.129Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M219.133 113.857C219.137 113.373 219.142 113.174 219.147 112.895C219.573 112.899 219.972 112.904 220.417 112.913C220.5 114.247 219.629 113.49 219.133 113.857Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M44.6289 110.45C45.111 110.455 45.3103 110.46 45.5884 110.464C45.5838 110.892 45.5792 111.291 45.5699 111.738C44.2442 111.821 44.9997 110.948 44.6289 110.45Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M262.227 160.027C262.556 160.241 262.89 160.459 263.446 160.822C263.038 161.021 262.737 161.17 262.473 161.3C262.315 161.059 261.513 160.817 262.227 160.027Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M42.9561 193.464C42.7567 193.254 42.5574 193.05 42.2793 192.766C42.6501 192.511 43.0024 192.265 43.3593 192.018C44.0222 192.85 43.2527 193.073 42.9561 193.464Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M105.348 155.319C104.964 155.105 104.579 154.892 104.115 154.636C104.43 154.38 104.648 154.204 104.959 153.948C105.181 154.255 105.432 154.599 105.677 154.938C105.566 155.064 105.459 155.194 105.348 155.319Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M153.779 175.614C154.177 175.981 154.386 176.171 154.678 176.441C154.228 176.678 153.834 176.887 152.963 177.342C153.375 176.478 153.552 176.097 153.779 175.614Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M266.989 72.8497C267.077 73.2912 267.128 73.5375 267.198 73.8861C266.692 73.8814 266.298 73.8721 265.594 73.8628C266.164 73.4492 266.507 73.1983 266.989 72.8497Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M245.771 78.1986C246.536 78.2079 246.884 78.2126 247.417 78.2218C247.324 78.575 247.255 78.8446 247.125 79.3465C246.624 78.9236 246.318 78.6633 245.771 78.1986Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M33.8438 198.32C34.502 198.329 34.7013 198.334 34.9701 198.334C34.9655 198.766 34.9609 199.161 34.947 199.872C34.5344 199.286 34.2887 198.938 33.8438 198.32Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M78.9312 182.055C78.8432 181.613 78.7922 181.367 78.7227 181.018C79.2279 181.023 79.6219 181.032 80.3265 181.042C79.7563 181.455 79.4133 181.701 78.9312 182.055Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M230.462 197.098C230.453 197.758 230.448 197.957 230.448 198.227C230.017 198.222 229.623 198.218 228.914 198.204C229.493 197.79 229.846 197.539 230.462 197.098Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M210.025 203.515C209.844 203.213 209.664 202.907 209.455 202.563C209.761 202.549 210.155 202.53 210.762 202.498C210.651 202.916 210.577 203.185 210.503 203.46C210.345 203.478 210.187 203.497 210.025 203.515Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M71.7598 178.188C72.5663 178.197 72.914 178.202 73.5722 178.211C73.1828 178.611 72.9464 178.857 72.5617 179.252C72.316 178.932 72.1445 178.699 71.7598 178.188Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M133.722 178.03C133.013 178.021 132.619 178.016 132.113 178.007C132.178 177.668 132.229 177.417 132.317 176.97C132.804 177.338 133.147 177.598 133.722 178.03Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M258.658 118.072C258.57 117.63 258.519 117.384 258.449 117.035C258.954 117.04 259.348 117.049 260.053 117.059C259.483 117.468 259.14 117.719 258.658 118.072Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M146.427 110.52C146.604 111.793 146.084 112.054 145.514 112.323C145.185 111.403 146.057 111.403 146.427 110.52Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M51.1237 120.725C51.3045 121.027 51.4853 121.334 51.6939 121.678C51.3926 121.692 50.9986 121.711 50.3867 121.743C50.498 121.325 50.5721 121.055 50.6463 120.781C50.7993 120.763 50.9615 120.744 51.1237 120.725Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M65.5444 158.977C65.1273 158.396 64.8816 158.052 64.5293 157.559C64.9743 157.476 65.22 157.429 65.5676 157.364C65.5583 157.871 65.5537 158.266 65.5444 158.977Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M137.361 171.459C138.126 171.468 138.474 171.473 139.007 171.482C138.914 171.835 138.845 172.105 138.715 172.607C138.219 172.184 137.913 171.928 137.361 171.459Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M259.988 121.92C259.979 121.929 259.766 122.138 259.524 122.37C259.334 122.147 259.144 121.924 258.922 121.659C259.079 121.492 259.27 121.292 259.599 120.944C259.733 121.278 259.858 121.599 259.988 121.92Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M199.062 168.903C199.276 168.694 199.489 168.485 199.73 168.252C199.929 168.448 200.133 168.643 200.481 168.977C200.207 169.168 199.943 169.354 199.684 169.54C199.48 169.33 199.271 169.117 199.062 168.903Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M66.7227 117.356C66.7273 116.961 66.7319 116.566 66.7412 116.143C67.0193 116.148 67.214 116.148 67.6544 116.157C67.4087 116.668 67.2233 117.059 67.0425 117.449C66.9312 117.417 66.8246 117.384 66.7227 117.356Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M26.3344 82.0883C26.1212 82.2975 25.908 82.5066 25.6669 82.7389C25.4676 82.5438 25.2637 82.3486 24.916 82.014C25.1895 81.8234 25.4537 81.6375 25.7133 81.4517C25.9219 81.6608 26.1258 81.8746 26.3344 82.0883Z",
    fill: "#B8AC97"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M2.52555 61.5245C1.92758 61.5152 1.66337 61.5105 1.26473 61.5059C0.903168 60.8181 0.504526 60.056 0.00390625 59.0986C0.796554 59.1079 1.30181 59.1172 1.91831 59.1265C2.08982 59.8236 2.27987 60.5672 2.52555 61.5245Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M3.79057 50.2596C4.22166 50.2643 4.54614 50.2689 4.93551 50.2736C4.92624 50.822 4.9216 51.3331 4.91233 51.9419C3.89719 51.8304 3.63761 51.2774 3.79057 50.2596Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M8.31614 38.5672C8.07973 38.0561 7.88968 37.6425 7.59766 37.0104C7.8526 36.9082 8.18171 36.7734 8.48765 36.6479C9.10415 37.4147 9.10415 37.4147 8.31614 38.5672Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M4.55514 57.1886C3.9201 56.8122 3.56317 56.5984 3.13672 56.3475C3.53536 56.0501 3.84129 55.8223 4.34655 55.4459C4.42535 56.0733 4.4717 56.473 4.55514 57.1886Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M7.65145 12.975C7.35942 12.7334 7.06739 12.4964 6.73828 12.2268C7.07203 11.9712 7.37333 11.7389 7.87858 11.3439C7.96202 11.9852 8.01301 12.3802 8.064 12.7752C7.92493 12.8449 7.78587 12.91 7.65145 12.975Z",
    fill: "#B8AC97"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M99.7536 130.563C101.835 128.593 101.751 128.509 103.833 126.539C105.914 124.569 105.951 124.61 108.028 122.64C110.109 120.67 110.128 120.688 112.209 118.718C114.29 116.747 114.193 116.645 116.274 114.675C118.355 112.704 118.471 112.83 120.552 110.859C122.634 108.889 122.643 108.903 124.724 106.932C126.806 104.962 126.755 104.911 128.836 102.94C130.917 100.97 130.903 100.956 132.98 98.9857C135.061 97.0152 135.094 97.0524 137.175 95.082C139.256 93.1116 139.163 93.014 141.24 91.0436C143.321 89.0732 143.456 89.2172 145.537 87.2468C147.618 85.2764 147.549 85.2067 149.63 83.2363C151.711 81.2658 151.665 81.2147 153.742 79.2443C155.823 77.2739 155.925 77.3808 158.006 75.4103C160.088 73.4399 160.046 73.3934 162.127 71.4184C164.208 69.448 164.111 69.3411 166.192 67.3707C166.382 67.1894 166.721 67.3102 166.911 67.4915C169.298 69.7826 169.344 69.7314 171.727 72.0225C174.114 74.3136 174.174 74.2485 176.562 76.5443C178.949 78.8353 178.94 78.8493 181.327 81.1404C181.526 81.3309 181.424 81.6748 181.225 81.87C179.171 83.8869 179.194 83.9147 177.146 85.9316C175.092 87.9532 175.088 87.9439 173.034 89.9654C170.981 91.987 170.92 91.9265 168.867 93.9434C166.813 95.965 166.971 96.123 164.918 98.1445C162.864 100.166 162.813 100.115 160.76 102.132C158.706 104.153 158.748 104.195 156.694 106.217C154.641 108.238 154.641 108.238 152.587 110.26C150.534 112.281 150.506 112.249 148.453 114.27C146.399 116.292 146.371 116.259 144.318 118.281C142.265 120.302 142.209 120.242 140.155 122.264C138.102 124.285 138.153 124.336 136.099 126.358C134.046 128.379 133.981 128.314 131.928 130.336C129.874 132.357 129.967 132.45 127.909 134.472C125.855 136.493 125.795 136.433 123.742 138.454C121.688 140.476 121.697 140.49 119.644 142.511C117.59 144.533 117.604 144.547 115.546 146.569C115.356 146.759 115.004 146.787 114.814 146.596C112.918 144.677 112.955 144.64 111.059 142.725C109.163 140.811 109.196 140.778 107.3 138.859C105.404 136.939 105.335 137.005 103.439 135.09C101.543 133.171 101.515 133.198 99.6191 131.279C99.443 131.065 99.5542 130.749 99.7536 130.563Z",
    fill: "#E2EB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.483 69.1598C166.188 67.8075 166.281 67.8539 166.985 66.5016C167.69 65.1446 167.648 65.126 168.353 63.769C169.057 62.4121 168.575 62.1611 169.28 60.8041C169.984 59.4471 169.915 59.3914 170.68 58.0716C171.264 57.3326 172.413 57.2908 173.229 56.9748C174.073 56.6495 174.847 56.3474 175.737 56.4915C176.604 56.6309 177.503 56.8261 178.226 57.4256C179.292 58.3132 179.288 58.3179 180.358 59.2055C181.424 60.0931 181.401 60.1256 182.467 61.0132C183.534 61.9009 183.631 61.7847 184.697 62.6723C185.763 63.5599 185.805 63.5134 186.871 64.4011C187.942 65.2887 187.64 65.6512 188.711 66.5388C189.782 67.4264 190.018 67.1429 191.085 68.0305C192.151 68.9181 191.919 69.2016 192.99 70.0939C193.778 70.7492 194.575 71.3672 194.858 72.2641C195.15 73.1982 195.015 74.2206 194.76 75.164C194.515 76.0749 193.996 76.8277 193.24 77.5155C191.947 78.2358 192.081 78.51 190.737 79.1281C189.393 79.7462 189.179 79.2814 187.84 79.8995C186.496 80.5176 186.472 80.4711 185.128 81.0892C183.784 81.7073 183.872 81.9025 182.528 82.5205C181.183 83.1386 181.207 83.1944 179.862 83.8125C179.542 83.9612 179.264 83.7846 179.014 83.5336C178.05 82.5438 177.763 82.8226 176.798 81.8328C175.834 80.8429 176.261 80.4246 175.296 79.4301C174.332 78.4403 174.124 78.6448 173.16 77.6503C172.195 76.6604 172.042 76.8045 171.078 75.8146C170.114 74.8201 170.434 74.5087 169.47 73.5142C168.506 72.5197 168.367 72.6545 167.402 71.66C166.438 70.6655 166.128 70.9676 165.164 69.9731C164.997 69.7965 165.368 69.3782 165.483 69.1598Z",
    fill: "#B8AC97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7021 130.503L95.1641 153.511L114.864 146.545L115.685 141.614L107.763 136.489L112.88 129.337L99.7021 130.503Z",
    fill: "#D34E00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273,
    height: 208,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.c3bb6ad287eddc09c1cac8549d03202f.svg";
export { ForwardRef as ReactComponent };